module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-LightItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-LightItalic.eot
// module id = 1902
// module chunks = 0